import { Modal } from "@/utils/bootstrap";
import DetectSwipeClose from "@/app/components/lib/DetectSwipeClose";
import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  children: any;
  show: boolean;
  setShow: (show: boolean) => void;
}
const CountryCodeDrawer: React.FC<Props> = ({ children, show, setShow }) => {
  const isRtl = useIsRtl();
  return (
    <DetectSwipeClose isRtl={isRtl} onClose={() => setShow(false)} width={306}>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className={`modal-as-drawer filter fade drawer ${
          isRtl ? "right-align" : "left-align"
        }`}
      >
        <div> {children}</div>
      </Modal>
    </DetectSwipeClose>
  );
};

export default CountryCodeDrawer;
